<div class="p-4">
    <div>
        <app-freshpass-title></app-freshpass-title>
    </div>
    <div>
        <app-change-plan *ngIf="!!userSubscriptionDetails && !updatePlan && fetchedPlans" [currentEnvironment]="currentEnvironment"
            [userInfo]="userInfo" [userSubscriptionDetails]="userSubscriptionDetails" [fetchedPlans]="fetchedPlans">
        </app-change-plan>
    </div>
    <div *ngIf="showLoader" class="row">
        <div class="col-lg-6 col-md-12">
            <div class="loading-div-tiny" id="freshpass-loading">
                <div class="loading-spinner">
                    <div alt="Loading..." class="large progress">
                        <div class="prog1">
                            <div class="prog2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!showLoader && !updatePlan && !enableSnap"
        [ngTemplateOutlet]="planCardWithOutSnap"></ng-container>
    <ng-container *ngIf="!showLoader && !updatePlan && enableSnap" [ngTemplateOutlet]="planCardWithSnap"></ng-container>



    <div *ngIf="!showLoader">
        <payment-modal *ngIf="updatePlan" [changeCode]="changeCode" [retentionPlanDiscount]="retentionPlanDiscount"
            [currentEnvironment]="currentEnvironment" [userEnrollmentDetails]="userEnrollmentDetails"
            [tenderInfo]="tenderInfo" [termsID]="termsID" [userInfo]="userInfo"></payment-modal>
    </div>
</div>

<div *ngIf="!showLoader && !showPlanTypes" class="row">
</div>

<ng-template #planCardWithOutSnap>
    <div class="row container">
        <div class="col-lg-6 col-md-12 pr-0">
            <app-annual-plan (changePlan)="changePlan($event)" *ngIf="!!annualPlan" [annualPlan]="annualPlan"
                [monthlyPlan]="monthlyPlan" [currentEnvironment]="currentEnvironment"></app-annual-plan>
        </div>
        <div class="col-lg-6 col-md-12 pr-0">
            <app-monthly-plan (changePlan)="changePlan($event)" *ngIf="!!monthlyPlan"
                [currentEnvironment]="currentEnvironment" [monthlyPlan]="monthlyPlan"></app-monthly-plan>
        </div>
    </div>
</ng-template>
<ng-template #planCardWithSnap>
    <div class="row">
        <ng-container *ngIf="combinedPlans">
            <ng-container *ngIf="combinedPlans.length >= 3">
                <div class="mb-2" *ngFor="let plan of combinedPlans; let i = index"
                    [ngClass]="{ 'col-12': i === 0, 'col-lg-6 col-sm-12 col-md-12': i > 0 && i < 3 }">
                    <app-plan-card [planCard]="plan"
                        (actionChange)="changePlan(plan.details?.code,plan.title)"></app-plan-card>
                </div>
            </ng-container>
            <ng-container *ngIf="combinedPlans.length <= 2">
                <div class="col-12 mb-2" *ngFor="let plan of combinedPlans">
                    <app-plan-card [planCard]="plan"
                        (actionChange)="changePlan(plan.details?.code,plan.title)"></app-plan-card>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>